// extracted by mini-css-extract-plugin
export default {"section-main":"Main_section-main__A1PTc","head":"Main_head__ua4m8","divider":"Main_divider__VlWh5","body":"Main_body__fpgwv"};